{
  "version": 1,
  "asset_id": "34c69ffb-c9f5-4579-8f72-773c570d82ee",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/34c69ffb-c9f5-4579-8f72-773c570d82ee/thumb-ecologies.webp",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/34c69ffb-c9f5-4579-8f72-773c570d82ee/thumb-ecologies.webp",
  "original_filename": "thumb-ecologies.webp",
  "size": 145626,
  "content_type": "image/webp",
  "created_at": "2026-08-30T13:03:39Z"
}
